"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @return [{ alpha2: string, alpha3: string, name: string, currency: string, currencySymbol: string }]
 */
module.exports = [
    {
        alpha2: 'AF',
        alpha3: 'AFG',
        name: 'Afghanistan',
        currency: 'AFN',
        currencySymbol: '؋',
    },
    {
        alpha2: 'AL',
        alpha3: 'ALB',
        name: 'Albania',
        currency: 'ALL',
        currencySymbol: 'L',
    },
    {
        alpha2: 'DZ',
        alpha3: 'DZA',
        name: 'Algeria',
        currency: 'DZD',
        currencySymbol: 'د.ج',
    },
    {
        alpha2: 'AS',
        alpha3: 'ASM',
        name: 'American Samoa',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'AD',
        alpha3: 'AND',
        name: 'Andorra',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'AO',
        alpha3: 'AGO',
        name: 'Angola',
        currency: 'AOA',
        currencySymbol: 'Kz',
    },
    {
        alpha2: 'AI',
        alpha3: 'AIA',
        name: 'Anguilla',
        currency: 'XCD',
        currencySymbol: '$',
    },
    {
        alpha2: 'AQ',
        alpha3: 'ATA',
        name: 'Antarctica',
        currency: null,
    },
    {
        alpha2: 'AG',
        alpha3: 'ATG',
        name: 'Antigua and Barbuda',
        currency: 'XCD',
        currencySymbol: '$',
    },
    {
        alpha2: 'AR',
        alpha3: 'ARG',
        name: 'Argentina',
        currency: 'ARS',
        currencySymbol: '$',
    },
    {
        alpha2: 'AM',
        alpha3: 'ARM',
        name: 'Armenia',
        currency: 'AMD',
        currencySymbol: '֏',
    },
    {
        alpha2: 'AW',
        alpha3: 'ABW',
        name: 'Aruba',
        currency: 'AWG',
        currencySymbol: 'ƒ',
    },
    {
        alpha2: 'AU',
        alpha3: 'AUS',
        name: 'Australia',
        currency: 'AUD',
        currencySymbol: '$',
    },
    {
        alpha2: 'AT',
        alpha3: 'AUT',
        name: 'Austria',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'AZ',
        alpha3: 'AZE',
        name: 'Azerbaijan',
        currency: 'AZN',
        currencySymbol: '₼',
    },
    {
        alpha2: 'BS',
        alpha3: 'BHS',
        name: 'Bahamas',
        currency: 'BSD',
        currencySymbol: '$',
    },
    {
        alpha2: 'BH',
        alpha3: 'BHR',
        name: 'Bahrain',
        currency: 'BHD',
        currencySymbol: '.د.ب',
    },
    {
        alpha2: 'BD',
        alpha3: 'BGD',
        name: 'Bangladesh',
        currency: 'BDT',
        currencySymbol: '৳',
    },
    {
        alpha2: 'BB',
        alpha3: 'BRB',
        name: 'Barbados',
        currency: 'BBD',
        currencySymbol: '$',
    },
    {
        alpha2: 'BY',
        alpha3: 'BLR',
        name: 'Belarus',
        currency: 'BYN',
        currencySymbol: 'Br',
    },
    {
        alpha2: 'BE',
        alpha3: 'BEL',
        name: 'Belgium',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'BZ',
        alpha3: 'BLZ',
        name: 'Belize',
        currency: 'BZD',
        currencySymbol: '$',
    },
    {
        alpha2: 'BJ',
        alpha3: 'BEN',
        name: 'Benin',
        currency: 'XOF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'BM',
        alpha3: 'BMU',
        name: 'Bermuda',
        currency: 'BMD',
        currencySymbol: '$',
    },
    {
        alpha2: 'BT',
        alpha3: 'BTN',
        name: 'Bhutan',
        currency: 'BTN',
        currencySymbol: 'Nu.',
    },
    {
        alpha2: 'BO',
        alpha3: 'BOL',
        name: 'Bolivia',
        currency: 'BOB',
        currencySymbol: 'Bs.',
    },
    {
        alpha2: 'BA',
        alpha3: 'BIH',
        name: 'Bosnia and Herzegovina',
        currency: 'BAM',
        currencySymbol: 'KM',
    },
    {
        alpha2: 'BW',
        alpha3: 'BWA',
        name: 'Botswana',
        currency: 'BWP',
        currencySymbol: 'P',
    },
    {
        alpha2: 'BV',
        alpha3: 'BVT',
        name: 'Bouvet Island',
        currency: null,
    },
    {
        alpha2: 'BR',
        alpha3: 'BRA',
        name: 'Brazil',
        currency: 'BRL',
        currencySymbol: 'R$',
    },
    {
        alpha2: 'IO',
        alpha3: 'IOT',
        name: 'British Indian Ocean Territory',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'VG',
        alpha3: 'VGB',
        name: 'British Virgin Islands',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'BN',
        alpha3: 'BRN',
        name: 'Brunei',
        currency: 'BND',
        currencySymbol: '$',
    },
    {
        alpha2: 'BG',
        alpha3: 'BGR',
        name: 'Bulgaria',
        currency: 'BGN',
        currencySymbol: 'лв',
    },
    {
        alpha2: 'BF',
        alpha3: 'BFA',
        name: 'Burkina Faso',
        currency: 'XOF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'BI',
        alpha3: 'BDI',
        name: 'Burundi',
        currency: 'BIF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'KH',
        alpha3: 'KHM',
        name: 'Cambodia',
        currency: 'KHR',
        currencySymbol: '៛',
    },
    {
        alpha2: 'CM',
        alpha3: 'CMR',
        name: 'Cameroon',
        currency: 'XAF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'CA',
        alpha3: 'CAN',
        name: 'Canada',
        currency: 'CAD',
        currencySymbol: '$',
    },
    {
        alpha2: 'CV',
        alpha3: 'CPV',
        name: 'Cape Verde',
        currency: 'CVE',
        currencySymbol: 'Esc',
    },
    {
        alpha2: 'BQ',
        alpha3: 'BES',
        name: 'Caribbean Netherlands',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'KY',
        alpha3: 'CYM',
        name: 'Cayman Islands',
        currency: 'KYD',
        currencySymbol: '$',
    },
    {
        alpha2: 'CF',
        alpha3: 'CAF',
        name: 'Central African Republic',
        currency: 'XAF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'TD',
        alpha3: 'TCD',
        name: 'Chad',
        currency: 'XAF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'CL',
        alpha3: 'CHL',
        name: 'Chile',
        currency: 'CLP',
        currencySymbol: '$',
    },
    {
        alpha2: 'CN',
        alpha3: 'CHN',
        name: 'China',
        currency: 'CNY',
        currencySymbol: '¥',
    },
    {
        alpha2: 'CX',
        alpha3: 'CXR',
        name: 'Christmas Island',
        currency: 'AUD',
        currencySymbol: '$',
    },
    {
        alpha2: 'CC',
        alpha3: 'CCK',
        name: 'Cocos (Keeling) Islands',
        currency: 'AUD',
        currencySymbol: '$',
    },
    {
        alpha2: 'CO',
        alpha3: 'COL',
        name: 'Colombia',
        currency: 'COP',
        currencySymbol: '$',
    },
    {
        alpha2: 'KM',
        alpha3: 'COM',
        name: 'Comoros',
        currency: 'KMF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'CK',
        alpha3: 'COK',
        name: 'Cook Islands',
        currency: 'CKD',
        currencySymbol: '$',
    },
    {
        alpha2: 'CR',
        alpha3: 'CRI',
        name: 'Costa Rica',
        currency: 'CRC',
        currencySymbol: '₡',
    },
    {
        alpha2: 'HR',
        alpha3: 'HRV',
        name: 'Croatia',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'CU',
        alpha3: 'CUB',
        name: 'Cuba',
        currency: 'CUC',
        currencySymbol: '$',
    },
    {
        alpha2: 'CW',
        alpha3: 'CUW',
        name: 'Curaçao',
        currency: 'ANG',
        currencySymbol: 'ƒ',
    },
    {
        alpha2: 'CY',
        alpha3: 'CYP',
        name: 'Cyprus',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'CZ',
        alpha3: 'CZE',
        name: 'Czechia',
        currency: 'CZK',
        currencySymbol: 'Kč',
    },
    {
        alpha2: 'CD',
        alpha3: 'COD',
        name: 'DR Congo',
        currency: 'CDF',
        currencySymbol: 'FC',
    },
    {
        alpha2: 'DK',
        alpha3: 'DNK',
        name: 'Denmark',
        currency: 'DKK',
        currencySymbol: 'kr',
    },
    {
        alpha2: 'DJ',
        alpha3: 'DJI',
        name: 'Djibouti',
        currency: 'DJF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'DM',
        alpha3: 'DMA',
        name: 'Dominica',
        currency: 'XCD',
        currencySymbol: '$',
    },
    {
        alpha2: 'DO',
        alpha3: 'DOM',
        name: 'Dominican Republic',
        currency: 'DOP',
        currencySymbol: '$',
    },
    {
        alpha2: 'EC',
        alpha3: 'ECU',
        name: 'Ecuador',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'EG',
        alpha3: 'EGY',
        name: 'Egypt',
        currency: 'EGP',
        currencySymbol: '£',
    },
    {
        alpha2: 'SV',
        alpha3: 'SLV',
        name: 'El Salvador',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'GQ',
        alpha3: 'GNQ',
        name: 'Equatorial Guinea',
        currency: 'XAF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'ER',
        alpha3: 'ERI',
        name: 'Eritrea',
        currency: 'ERN',
        currencySymbol: 'Nfk',
    },
    {
        alpha2: 'EE',
        alpha3: 'EST',
        name: 'Estonia',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'SZ',
        alpha3: 'SWZ',
        name: 'Eswatini',
        currency: 'SZL',
        currencySymbol: 'L',
    },
    {
        alpha2: 'ET',
        alpha3: 'ETH',
        name: 'Ethiopia',
        currency: 'ETB',
        currencySymbol: 'Br',
    },
    {
        alpha2: 'FK',
        alpha3: 'FLK',
        name: 'Falkland Islands',
        currency: 'FKP',
        currencySymbol: '£',
    },
    {
        alpha2: 'FO',
        alpha3: 'FRO',
        name: 'Faroe Islands',
        currency: 'DKK',
        currencySymbol: 'kr',
    },
    {
        alpha2: 'FJ',
        alpha3: 'FJI',
        name: 'Fiji',
        currency: 'FJD',
        currencySymbol: '$',
    },
    {
        alpha2: 'FI',
        alpha3: 'FIN',
        name: 'Finland',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'FR',
        alpha3: 'FRA',
        name: 'France',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'GF',
        alpha3: 'GUF',
        name: 'French Guiana',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'PF',
        alpha3: 'PYF',
        name: 'French Polynesia',
        currency: 'XPF',
        currencySymbol: '₣',
    },
    {
        alpha2: 'TF',
        alpha3: 'ATF',
        name: 'French Southern and Antarctic Lands',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'GA',
        alpha3: 'GAB',
        name: 'Gabon',
        currency: 'XAF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'GM',
        alpha3: 'GMB',
        name: 'Gambia',
        currency: 'GMD',
        currencySymbol: 'D',
    },
    {
        alpha2: 'GE',
        alpha3: 'GEO',
        name: 'Georgia',
        currency: 'GEL',
        currencySymbol: '₾',
    },
    {
        alpha2: 'DE',
        alpha3: 'DEU',
        name: 'Germany',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'GH',
        alpha3: 'GHA',
        name: 'Ghana',
        currency: 'GHS',
        currencySymbol: '₵',
    },
    {
        alpha2: 'GI',
        alpha3: 'GIB',
        name: 'Gibraltar',
        currency: 'GIP',
        currencySymbol: '£',
    },
    {
        alpha2: 'GR',
        alpha3: 'GRC',
        name: 'Greece',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'GL',
        alpha3: 'GRL',
        name: 'Greenland',
        currency: 'DKK',
        currencySymbol: 'kr.',
    },
    {
        alpha2: 'GD',
        alpha3: 'GRD',
        name: 'Grenada',
        currency: 'XCD',
        currencySymbol: '$',
    },
    {
        alpha2: 'GP',
        alpha3: 'GLP',
        name: 'Guadeloupe',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'GU',
        alpha3: 'GUM',
        name: 'Guam',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'GT',
        alpha3: 'GTM',
        name: 'Guatemala',
        currency: 'GTQ',
        currencySymbol: 'Q',
    },
    {
        alpha2: 'GG',
        alpha3: 'GGY',
        name: 'Guernsey',
        currency: 'GBP',
        currencySymbol: '£',
    },
    {
        alpha2: 'GN',
        alpha3: 'GIN',
        name: 'Guinea',
        currency: 'GNF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'GW',
        alpha3: 'GNB',
        name: 'Guinea-Bissau',
        currency: 'XOF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'GY',
        alpha3: 'GUY',
        name: 'Guyana',
        currency: 'GYD',
        currencySymbol: '$',
    },
    {
        alpha2: 'HT',
        alpha3: 'HTI',
        name: 'Haiti',
        currency: 'HTG',
        currencySymbol: 'G',
    },
    {
        alpha2: 'HM',
        alpha3: 'HMD',
        name: 'Heard Island and McDonald Islands',
        currency: null,
    },
    {
        alpha2: 'HN',
        alpha3: 'HND',
        name: 'Honduras',
        currency: 'HNL',
        currencySymbol: 'L',
    },
    {
        alpha2: 'HK',
        alpha3: 'HKG',
        name: 'Hong Kong',
        currency: 'HKD',
        currencySymbol: '$',
    },
    {
        alpha2: 'HU',
        alpha3: 'HUN',
        name: 'Hungary',
        currency: 'HUF',
        currencySymbol: 'Ft',
    },
    {
        alpha2: 'IS',
        alpha3: 'ISL',
        name: 'Iceland',
        currency: 'ISK',
        currencySymbol: 'kr',
    },
    {
        alpha2: 'IN',
        alpha3: 'IND',
        name: 'India',
        currency: 'INR',
        currencySymbol: '₹',
    },
    {
        alpha2: 'ID',
        alpha3: 'IDN',
        name: 'Indonesia',
        currency: 'IDR',
        currencySymbol: 'Rp',
    },
    {
        alpha2: 'IR',
        alpha3: 'IRN',
        name: 'Iran',
        currency: 'IRR',
        currencySymbol: '﷼',
    },
    {
        alpha2: 'IQ',
        alpha3: 'IRQ',
        name: 'Iraq',
        currency: 'IQD',
        currencySymbol: 'ع.د',
    },
    {
        alpha2: 'IE',
        alpha3: 'IRL',
        name: 'Ireland',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'IM',
        alpha3: 'IMN',
        name: 'Isle of Man',
        currency: 'GBP',
        currencySymbol: '£',
    },
    {
        alpha2: 'IL',
        alpha3: 'ISR',
        name: 'Israel',
        currency: 'ILS',
        currencySymbol: '₪',
    },
    {
        alpha2: 'IT',
        alpha3: 'ITA',
        name: 'Italy',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'CI',
        alpha3: 'CIV',
        name: 'Ivory Coast',
        currency: 'XOF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'JM',
        alpha3: 'JAM',
        name: 'Jamaica',
        currency: 'JMD',
        currencySymbol: '$',
    },
    {
        alpha2: 'JP',
        alpha3: 'JPN',
        name: 'Japan',
        currency: 'JPY',
        currencySymbol: '¥',
    },
    {
        alpha2: 'JE',
        alpha3: 'JEY',
        name: 'Jersey',
        currency: 'GBP',
        currencySymbol: '£',
    },
    {
        alpha2: 'JO',
        alpha3: 'JOR',
        name: 'Jordan',
        currency: 'JOD',
        currencySymbol: 'د.ا',
    },
    {
        alpha2: 'KZ',
        alpha3: 'KAZ',
        name: 'Kazakhstan',
        currency: 'KZT',
        currencySymbol: '₸',
    },
    {
        alpha2: 'KE',
        alpha3: 'KEN',
        name: 'Kenya',
        currency: 'KES',
        currencySymbol: 'Sh',
    },
    {
        alpha2: 'KI',
        alpha3: 'KIR',
        name: 'Kiribati',
        currency: 'AUD',
        currencySymbol: '$',
    },
    {
        alpha2: 'XK',
        alpha3: 'UNK',
        name: 'Kosovo',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'KW',
        alpha3: 'KWT',
        name: 'Kuwait',
        currency: 'KWD',
        currencySymbol: 'د.ك',
    },
    {
        alpha2: 'KG',
        alpha3: 'KGZ',
        name: 'Kyrgyzstan',
        currency: 'KGS',
        currencySymbol: 'с',
    },
    {
        alpha2: 'LA',
        alpha3: 'LAO',
        name: 'Laos',
        currency: 'LAK',
        currencySymbol: '₭',
    },
    {
        alpha2: 'LV',
        alpha3: 'LVA',
        name: 'Latvia',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'LB',
        alpha3: 'LBN',
        name: 'Lebanon',
        currency: 'LBP',
        currencySymbol: 'ل.ل',
    },
    {
        alpha2: 'LS',
        alpha3: 'LSO',
        name: 'Lesotho',
        currency: 'LSL',
        currencySymbol: 'L',
    },
    {
        alpha2: 'LR',
        alpha3: 'LBR',
        name: 'Liberia',
        currency: 'LRD',
        currencySymbol: '$',
    },
    {
        alpha2: 'LY',
        alpha3: 'LBY',
        name: 'Libya',
        currency: 'LYD',
        currencySymbol: 'ل.د',
    },
    {
        alpha2: 'LI',
        alpha3: 'LIE',
        name: 'Liechtenstein',
        currency: 'CHF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'LT',
        alpha3: 'LTU',
        name: 'Lithuania',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'LU',
        alpha3: 'LUX',
        name: 'Luxembourg',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'MO',
        alpha3: 'MAC',
        name: 'Macau',
        currency: 'MOP',
        currencySymbol: 'P',
    },
    {
        alpha2: 'MG',
        alpha3: 'MDG',
        name: 'Madagascar',
        currency: 'MGA',
        currencySymbol: 'Ar',
    },
    {
        alpha2: 'MW',
        alpha3: 'MWI',
        name: 'Malawi',
        currency: 'MWK',
        currencySymbol: 'MK',
    },
    {
        alpha2: 'MY',
        alpha3: 'MYS',
        name: 'Malaysia',
        currency: 'MYR',
        currencySymbol: 'RM',
    },
    {
        alpha2: 'MV',
        alpha3: 'MDV',
        name: 'Maldives',
        currency: 'MVR',
        currencySymbol: '.ރ',
    },
    {
        alpha2: 'ML',
        alpha3: 'MLI',
        name: 'Mali',
        currency: 'XOF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'MT',
        alpha3: 'MLT',
        name: 'Malta',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'MH',
        alpha3: 'MHL',
        name: 'Marshall Islands',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'MQ',
        alpha3: 'MTQ',
        name: 'Martinique',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'MR',
        alpha3: 'MRT',
        name: 'Mauritania',
        currency: 'MRU',
        currencySymbol: 'UM',
    },
    {
        alpha2: 'MU',
        alpha3: 'MUS',
        name: 'Mauritius',
        currency: 'MUR',
        currencySymbol: '₨',
    },
    {
        alpha2: 'YT',
        alpha3: 'MYT',
        name: 'Mayotte',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'MX',
        alpha3: 'MEX',
        name: 'Mexico',
        currency: 'MXN',
        currencySymbol: '$',
    },
    {
        alpha2: 'FM',
        alpha3: 'FSM',
        name: 'Micronesia',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'MD',
        alpha3: 'MDA',
        name: 'Moldova',
        currency: 'MDL',
        currencySymbol: 'L',
    },
    {
        alpha2: 'MC',
        alpha3: 'MCO',
        name: 'Monaco',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'MN',
        alpha3: 'MNG',
        name: 'Mongolia',
        currency: 'MNT',
        currencySymbol: '₮',
    },
    {
        alpha2: 'ME',
        alpha3: 'MNE',
        name: 'Montenegro',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'MS',
        alpha3: 'MSR',
        name: 'Montserrat',
        currency: 'XCD',
        currencySymbol: '$',
    },
    {
        alpha2: 'MA',
        alpha3: 'MAR',
        name: 'Morocco',
        currency: 'MAD',
        currencySymbol: 'د.م.',
    },
    {
        alpha2: 'MZ',
        alpha3: 'MOZ',
        name: 'Mozambique',
        currency: 'MZN',
        currencySymbol: 'MT',
    },
    {
        alpha2: 'MM',
        alpha3: 'MMR',
        name: 'Myanmar',
        currency: 'MMK',
        currencySymbol: 'Ks',
    },
    {
        alpha2: 'NA',
        alpha3: 'NAM',
        name: 'Namibia',
        currency: 'NAD',
        currencySymbol: '$',
    },
    {
        alpha2: 'NR',
        alpha3: 'NRU',
        name: 'Nauru',
        currency: 'AUD',
        currencySymbol: '$',
    },
    {
        alpha2: 'NP',
        alpha3: 'NPL',
        name: 'Nepal',
        currency: 'NPR',
        currencySymbol: '₨',
    },
    {
        alpha2: 'NL',
        alpha3: 'NLD',
        name: 'Netherlands',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'NC',
        alpha3: 'NCL',
        name: 'New Caledonia',
        currency: 'XPF',
        currencySymbol: '₣',
    },
    {
        alpha2: 'NZ',
        alpha3: 'NZL',
        name: 'New Zealand',
        currency: 'NZD',
        currencySymbol: '$',
    },
    {
        alpha2: 'NI',
        alpha3: 'NIC',
        name: 'Nicaragua',
        currency: 'NIO',
        currencySymbol: 'C$',
    },
    {
        alpha2: 'NE',
        alpha3: 'NER',
        name: 'Niger',
        currency: 'XOF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'NG',
        alpha3: 'NGA',
        name: 'Nigeria',
        currency: 'NGN',
        currencySymbol: '₦',
    },
    {
        alpha2: 'NU',
        alpha3: 'NIU',
        name: 'Niue',
        currency: 'NZD',
        currencySymbol: '$',
    },
    {
        alpha2: 'NF',
        alpha3: 'NFK',
        name: 'Norfolk Island',
        currency: 'AUD',
        currencySymbol: '$',
    },
    {
        alpha2: 'KP',
        alpha3: 'PRK',
        name: 'North Korea',
        currency: 'KPW',
        currencySymbol: '₩',
    },
    {
        alpha2: 'MK',
        alpha3: 'MKD',
        name: 'North Macedonia',
        currency: 'MKD',
        currencySymbol: 'den',
    },
    {
        alpha2: 'MP',
        alpha3: 'MNP',
        name: 'Northern Mariana Islands',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'NO',
        alpha3: 'NOR',
        name: 'Norway',
        currency: 'NOK',
        currencySymbol: 'kr',
    },
    {
        alpha2: 'OM',
        alpha3: 'OMN',
        name: 'Oman',
        currency: 'OMR',
        currencySymbol: 'ر.ع.',
    },
    {
        alpha2: 'PK',
        alpha3: 'PAK',
        name: 'Pakistan',
        currency: 'PKR',
        currencySymbol: '₨',
    },
    {
        alpha2: 'PW',
        alpha3: 'PLW',
        name: 'Palau',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'PS',
        alpha3: 'PSE',
        name: 'Palestine',
        currency: 'EGP',
        currencySymbol: 'E£',
    },
    {
        alpha2: 'PA',
        alpha3: 'PAN',
        name: 'Panama',
        currency: 'PAB',
        currencySymbol: 'B/.',
    },
    {
        alpha2: 'PG',
        alpha3: 'PNG',
        name: 'Papua New Guinea',
        currency: 'PGK',
        currencySymbol: 'K',
    },
    {
        alpha2: 'PY',
        alpha3: 'PRY',
        name: 'Paraguay',
        currency: 'PYG',
        currencySymbol: '₲',
    },
    {
        alpha2: 'PE',
        alpha3: 'PER',
        name: 'Peru',
        currency: 'PEN',
        currencySymbol: 'S/ ',
    },
    {
        alpha2: 'PH',
        alpha3: 'PHL',
        name: 'Philippines',
        currency: 'PHP',
        currencySymbol: '₱',
    },
    {
        alpha2: 'PN',
        alpha3: 'PCN',
        name: 'Pitcairn Islands',
        currency: 'NZD',
        currencySymbol: '$',
    },
    {
        alpha2: 'PL',
        alpha3: 'POL',
        name: 'Poland',
        currency: 'PLN',
        currencySymbol: 'zł',
    },
    {
        alpha2: 'PT',
        alpha3: 'PRT',
        name: 'Portugal',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'PR',
        alpha3: 'PRI',
        name: 'Puerto Rico',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'QA',
        alpha3: 'QAT',
        name: 'Qatar',
        currency: 'QAR',
        currencySymbol: 'ر.ق',
    },
    {
        alpha2: 'CG',
        alpha3: 'COG',
        name: 'Republic of the Congo',
        currency: 'XAF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'RO',
        alpha3: 'ROU',
        name: 'Romania',
        currency: 'RON',
        currencySymbol: 'lei',
    },
    {
        alpha2: 'RU',
        alpha3: 'RUS',
        name: 'Russia',
        currency: 'RUB',
        currencySymbol: '₽',
    },
    {
        alpha2: 'RW',
        alpha3: 'RWA',
        name: 'Rwanda',
        currency: 'RWF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'RE',
        alpha3: 'REU',
        name: 'Réunion',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'BL',
        alpha3: 'BLM',
        name: 'Saint Barthélemy',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'SH',
        alpha3: 'SHN',
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        currency: 'GBP',
        currencySymbol: '£',
    },
    {
        alpha2: 'KN',
        alpha3: 'KNA',
        name: 'Saint Kitts and Nevis',
        currency: 'XCD',
        currencySymbol: '$',
    },
    {
        alpha2: 'LC',
        alpha3: 'LCA',
        name: 'Saint Lucia',
        currency: 'XCD',
        currencySymbol: '$',
    },
    {
        alpha2: 'MF',
        alpha3: 'MAF',
        name: 'Saint Martin',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'PM',
        alpha3: 'SPM',
        name: 'Saint Pierre and Miquelon',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'VC',
        alpha3: 'VCT',
        name: 'Saint Vincent and the Grenadines',
        currency: 'XCD',
        currencySymbol: '$',
    },
    {
        alpha2: 'WS',
        alpha3: 'WSM',
        name: 'Samoa',
        currency: 'WST',
        currencySymbol: 'T',
    },
    {
        alpha2: 'SM',
        alpha3: 'SMR',
        name: 'San Marino',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'SA',
        alpha3: 'SAU',
        name: 'Saudi Arabia',
        currency: 'SAR',
        currencySymbol: 'ر.س',
    },
    {
        alpha2: 'SN',
        alpha3: 'SEN',
        name: 'Senegal',
        currency: 'XOF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'RS',
        alpha3: 'SRB',
        name: 'Serbia',
        currency: 'RSD',
        currencySymbol: 'дин.',
    },
    {
        alpha2: 'SC',
        alpha3: 'SYC',
        name: 'Seychelles',
        currency: 'SCR',
        currencySymbol: '₨',
    },
    {
        alpha2: 'SL',
        alpha3: 'SLE',
        name: 'Sierra Leone',
        currency: 'SLL',
        currencySymbol: 'Le',
    },
    {
        alpha2: 'SG',
        alpha3: 'SGP',
        name: 'Singapore',
        currency: 'SGD',
        currencySymbol: '$',
    },
    {
        alpha2: 'SX',
        alpha3: 'SXM',
        name: 'Sint Maarten',
        currency: 'ANG',
        currencySymbol: 'ƒ',
    },
    {
        alpha2: 'SK',
        alpha3: 'SVK',
        name: 'Slovakia',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'SI',
        alpha3: 'SVN',
        name: 'Slovenia',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'SB',
        alpha3: 'SLB',
        name: 'Solomon Islands',
        currency: 'SBD',
        currencySymbol: '$',
    },
    {
        alpha2: 'SO',
        alpha3: 'SOM',
        name: 'Somalia',
        currency: 'SOS',
        currencySymbol: 'Sh',
    },
    {
        alpha2: 'ZA',
        alpha3: 'ZAF',
        name: 'South Africa',
        currency: 'ZAR',
        currencySymbol: 'R',
    },
    {
        alpha2: 'GS',
        alpha3: 'SGS',
        name: 'South Georgia',
        currency: 'SHP',
        currencySymbol: '£',
    },
    {
        alpha2: 'KR',
        alpha3: 'KOR',
        name: 'South Korea',
        currency: 'KRW',
        currencySymbol: '₩',
    },
    {
        alpha2: 'SS',
        alpha3: 'SSD',
        name: 'South Sudan',
        currency: 'SSP',
        currencySymbol: '£',
    },
    {
        alpha2: 'ES',
        alpha3: 'ESP',
        name: 'Spain',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'LK',
        alpha3: 'LKA',
        name: 'Sri Lanka',
        currency: 'LKR',
        currencySymbol: 'Rs  රු',
    },
    {
        alpha2: 'SD',
        alpha3: 'SDN',
        name: 'Sudan',
        currency: 'SDG',
        currencySymbol: 'ج.س',
    },
    {
        alpha2: 'SR',
        alpha3: 'SUR',
        name: 'Suriname',
        currency: 'SRD',
        currencySymbol: '$',
    },
    {
        alpha2: 'SJ',
        alpha3: 'SJM',
        name: 'Svalbard and Jan Mayen',
        currency: 'NOK',
        currencySymbol: 'kr',
    },
    {
        alpha2: 'SE',
        alpha3: 'SWE',
        name: 'Sweden',
        currency: 'SEK',
        currencySymbol: 'kr',
    },
    {
        alpha2: 'CH',
        alpha3: 'CHE',
        name: 'Switzerland',
        currency: 'CHF',
        currencySymbol: 'Fr.',
    },
    {
        alpha2: 'SY',
        alpha3: 'SYR',
        name: 'Syria',
        currency: 'SYP',
        currencySymbol: '£',
    },
    {
        alpha2: 'ST',
        alpha3: 'STP',
        name: 'São Tomé and Príncipe',
        currency: 'STN',
        currencySymbol: 'Db',
    },
    {
        alpha2: 'TW',
        alpha3: 'TWN',
        name: 'Taiwan',
        currency: 'TWD',
        currencySymbol: '$',
    },
    {
        alpha2: 'TJ',
        alpha3: 'TJK',
        name: 'Tajikistan',
        currency: 'TJS',
        currencySymbol: 'ЅМ',
    },
    {
        alpha2: 'TZ',
        alpha3: 'TZA',
        name: 'Tanzania',
        currency: 'TZS',
        currencySymbol: 'Sh',
    },
    {
        alpha2: 'TH',
        alpha3: 'THA',
        name: 'Thailand',
        currency: 'THB',
        currencySymbol: '฿',
    },
    {
        alpha2: 'TL',
        alpha3: 'TLS',
        name: 'Timor-Leste',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'TG',
        alpha3: 'TGO',
        name: 'Togo',
        currency: 'XOF',
        currencySymbol: 'Fr',
    },
    {
        alpha2: 'TK',
        alpha3: 'TKL',
        name: 'Tokelau',
        currency: 'NZD',
        currencySymbol: '$',
    },
    {
        alpha2: 'TO',
        alpha3: 'TON',
        name: 'Tonga',
        currency: 'TOP',
        currencySymbol: 'T$',
    },
    {
        alpha2: 'TT',
        alpha3: 'TTO',
        name: 'Trinidad and Tobago',
        currency: 'TTD',
        currencySymbol: '$',
    },
    {
        alpha2: 'TN',
        alpha3: 'TUN',
        name: 'Tunisia',
        currency: 'TND',
        currencySymbol: 'د.ت',
    },
    {
        alpha2: 'TR',
        alpha3: 'TUR',
        name: 'Turkey',
        currency: 'TRY',
        currencySymbol: '₺',
    },
    {
        alpha2: 'TM',
        alpha3: 'TKM',
        name: 'Turkmenistan',
        currency: 'TMT',
        currencySymbol: 'm',
    },
    {
        alpha2: 'TC',
        alpha3: 'TCA',
        name: 'Turks and Caicos Islands',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'TV',
        alpha3: 'TUV',
        name: 'Tuvalu',
        currency: 'AUD',
        currencySymbol: '$',
    },
    {
        alpha2: 'UG',
        alpha3: 'UGA',
        name: 'Uganda',
        currency: 'UGX',
        currencySymbol: 'Sh',
    },
    {
        alpha2: 'UA',
        alpha3: 'UKR',
        name: 'Ukraine',
        currency: 'UAH',
        currencySymbol: '₴',
    },
    {
        alpha2: 'AE',
        alpha3: 'ARE',
        name: 'United Arab Emirates',
        currency: 'AED',
        currencySymbol: 'د.إ',
    },
    {
        alpha2: 'GB',
        alpha3: 'GBR',
        name: 'United Kingdom',
        currency: 'GBP',
        currencySymbol: '£',
    },
    {
        alpha2: 'US',
        alpha3: 'USA',
        name: 'United States',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'UM',
        alpha3: 'UMI',
        name: 'United States Minor Outlying Islands',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'VI',
        alpha3: 'VIR',
        name: 'United States Virgin Islands',
        currency: 'USD',
        currencySymbol: '$',
    },
    {
        alpha2: 'UY',
        alpha3: 'URY',
        name: 'Uruguay',
        currency: 'UYU',
        currencySymbol: '$',
    },
    {
        alpha2: 'UZ',
        alpha3: 'UZB',
        name: 'Uzbekistan',
        currency: 'UZS',
        currencySymbol: "so'm",
    },
    {
        alpha2: 'VU',
        alpha3: 'VUT',
        name: 'Vanuatu',
        currency: 'VUV',
        currencySymbol: 'Vt',
    },
    {
        alpha2: 'VA',
        alpha3: 'VAT',
        name: 'Vatican City',
        currency: 'EUR',
        currencySymbol: '€',
    },
    {
        alpha2: 'VE',
        alpha3: 'VEN',
        name: 'Venezuela',
        currency: 'VES',
        currencySymbol: 'Bs.S.',
    },
    {
        alpha2: 'VN',
        alpha3: 'VNM',
        name: 'Vietnam',
        currency: 'VND',
        currencySymbol: '₫',
    },
    {
        alpha2: 'WF',
        alpha3: 'WLF',
        name: 'Wallis and Futuna',
        currency: 'XPF',
        currencySymbol: '₣',
    },
    {
        alpha2: 'EH',
        alpha3: 'ESH',
        name: 'Western Sahara',
        currency: 'DZD',
        currencySymbol: 'دج',
    },
    {
        alpha2: 'YE',
        alpha3: 'YEM',
        name: 'Yemen',
        currency: 'YER',
        currencySymbol: '﷼',
    },
    {
        alpha2: 'ZM',
        alpha3: 'ZMB',
        name: 'Zambia',
        currency: 'ZMW',
        currencySymbol: 'ZK',
    },
    {
        alpha2: 'ZW',
        alpha3: 'ZWE',
        name: 'Zimbabwe',
        currency: 'ZWL',
        currencySymbol: '$',
    },
    {
        alpha2: 'AX',
        alpha3: 'ALA',
        name: 'Åland Islands',
        currency: 'EUR',
        currencySymbol: '€',
    },
];
//# sourceMappingURL=data:application/json;base64,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